<template>
  <div class="flex flex-grow">
    <ais-current-refinements class="flex flex-grow">
      <template #default="{ items, createURL }">
        <div
          v-for="refinementItem in items"
          :key="refinementItem.attribute"
          class="relative px-1"
        >
          <refinement-filter
            :refinement-item="refinementItem"
            :createURL="createURL"
            @update-refinement="handleRefinementUpdate(refinementItem, $event)"
          />
        </div>
      </template>
    </ais-current-refinements>
  </div>
</template>
<script setup>
import { AisCurrentRefinements } from "vue-instantsearch/vue3/es";
import RefinementFilter from "./Filters/CurrentRefinementFilter.vue";

const handleRefinementUpdate = (parent, refinement) => {
  parent.refine(refinement);
};
</script>
